<h3 mat-dialog-title>Återköp Klarna</h3>

<div mat-dialog-content>
  <p>Maxbelopp för återbetalning: {{data.maxRefund}} kr</p>

  <form *ngIf="klarnaForm" [formGroup]="klarnaForm" spellcheck="false">
    <div class="input">
      <mat-form-field>
        <mat-label>Summa att återbetala</mat-label>
        <input matInput type="number" autocomplete="off" formControlName="refundControl" min="0"
          max="{{data.maxRefund}}">
        <mat-error>Ogiltigt belopp</mat-error>
      </mat-form-field>
    </div>

    <div class="input">
      <mat-form-field>
        <mat-label>Anledning till återköp</mat-label>
        <input matInput type="text" autocomplete="off" formControlName="refundComment">
        <mat-error>Kommentar krävs</mat-error>
      </mat-form-field>
    </div>

    <div mat-dialog-actions class="dialog-actions">
      <button mat-button (click)="closeDialog()">Avbryt</button>
      <button mat-button [disabled]="!klarnaForm.valid || loading" [ngClass]="{'button': true ,'loading': loading}"
        (click)="handleRefund()">
        Genomför återbetalning
        <mat-spinner *ngIf="loading" diameter="25" color="accent"></mat-spinner>
      </button>
    </div>
  </form>
</div>